/* eslint-disable max-len */
import React, { useRef, useContext } from 'react';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import AnimatedHeading from '../../../../../components/Animation/AnimatedHeading';
import UpdateButton from '../../../../../components/UpdateButton';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import GlobalContext from '../../../../../components/Context/GloablContext';


const AccountPopup = ({
    handleClose, 
    tittle, 
    message, 
    sameAccountNames, 
    handleOnCLickActivate, 
    loadingActivation,
    crossMark,
    additionalMessage}) => {
    const outsideClickRef = useRef();  
    useOnClickOutside(outsideClickRef, () => {
        handleClose();
    });
    const {isSideNavBar} = useContext(GlobalContext)

    return (
        <AnimatedModel 
            Children={
                <div data-te-modal-init="" className={`fixed ${ isSideNavBar ? 'ml-[88px]' : 'ml-[270px]'} left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50`} id="modalforDeactivate" tabindex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                    <div ref={outsideClickRef} data-te-modal-dialog-ref="" className={`pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] ${ isSideNavBar ? '' : 'translate-x-[-10%]'} items-center justify-center opacity-1 transition-all duration-300 ease-in-out`}>
                        <div className="px-[24px] pointer-events-auto flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 min-w-[774px] max-w-[774px] p-3 relative">
                            {(tittle !== "") && <div className="flex flex-shrink-0 rounded-t-md pt-1 pb-4">
                                <AnimatedHeading className="text-f9 font-semibold text-[#031624]" Children={tittle} />
                                {/* <!--Close button--> */}
                             
                            </div>}
                            <div className={`relative ${crossMark ? "mt-6" : "pt-1"}`}>
                                {(additionalMessage !== "" && additionalMessage !== undefined) && <AnimatedHeading className="text-center mb-3" Children={additionalMessage} /> }
                                <AnimatedHeading className=" text-f7 font-semibold text-[#000000]" Children={message} />
                            </div>
                            <div className='border rounded-lg w-full mt-4 border-[#C2DCEF] p-2'>
                                <ul className='list-disc pl-6 py-1'>
                                    {sameAccountNames.map((name, index) => {
                                        return (
                                            <li className='py-1' key={index}>
                                                <AnimatedHeading className=" text-f7 font-semibold text-[#000000] list-disc" Children={name}/>
                                            </li>
                                        );
                                    }
                                    )}
                                </ul>
                                
                            </div>
                            <div className="flex mt-4 w-fit mx-auto pb-2">
                                <AnimatedButton
                                    handleClick={() => handleClose()} 
                                    className="cancl-btn1" 
                                    buttonName="Cancel"
                                    disabled={loadingActivation}
                                
                                />
                                <UpdateButton 
                                    id={"same_leger_approve"}
                                    classKey={`actn-btn1 reset_password_conf `}
                                    loading={loadingActivation} ButtonName="OK" handleOnCLick={handleOnCLickActivate}/>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
        
    );
}

export default AccountPopup;
